import React from 'react';
import { Chip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { useWaitlist } from '../../hooks/useWaitlist';

interface WaitlistStatusChipProps {
  size?: 'small' | 'medium';
  sx?: any;
}

const WaitlistStatusChip: React.FC<WaitlistStatusChipProps> = ({ 
  size = 'small',
  sx = {}
}) => {
  const { isWaitlistMember, config } = useWaitlist();

  if (isWaitlistMember) {
    return (
      <Chip 
        label={config.MESSAGES.WAITLIST_ENROLLMENT.chipLabel}
        color="warning"
        icon={<InfoIcon />}
        size={size}
        sx={{ 
          fontWeight: 600,
          ...sx
        }}
      />
    );
  }

  return null;
};

export default WaitlistStatusChip; 